module.exports = __webpack_public_path__ + "74c50e4af91d31b793909d92bbf991e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/video-thumbnail-1-introduction.png
// module id = 1935
// module chunks = 0